// src/pages/AdyenCheckoutPage.tsx
import { useEffect } from "react";
import AdyenPayment from "../../../Components/Payments/AdyenPayment";
import { FaXmark } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../Helpers/Hooks/useToast";
import { useDispatch, useSelector } from "react-redux";
import { clearAdyenSessionData } from "../../../Redux/Slices/SettingSlice";

export default function AdyenCheckoutPage() {
  const navigate = useNavigate();
  const toast = useToast();

  const dispatch = useDispatch();

  // 🔐 Get Adyen session from Redux
  const adyenSession = useSelector(
    (state: any) => state.SettingSlice.adyenSession
  );

  // 🚫 Block access if session is missing (back button / refresh / direct URL)
  useEffect(() => {
    if (!adyenSession?.id || !adyenSession?.sessionData) {
      navigate("/", { replace: true });
    }
  }, [adyenSession, navigate]);

  // 🧊 Disable background scroll while checkout is open
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  if (!adyenSession?.id || !adyenSession?.sessionData) return <p>Loading session…</p>;

  const clientKey = process.env.REACT_APP_ADYEN_CLIENT_KEY;
  if (!clientKey) {
    return <p style={{ color: "red" }}>Missing REACT_APP_ADYEN_CLIENT_KEY</p>;
  }

  const env = (process.env.REACT_APP_ADYEN_ENV === "live" ? "live" : "test") as
    | "test"
    | "live";

  const handleClose = () => {
    toast.warning(
      "Your order has moved to pending stage. Please retry the payment from My Orders."
    );
    dispatch(clearAdyenSessionData());
    navigate("/", { replace: true });
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      {/* ❌ Cross button positioned at the top-right corner of the entire modal */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          background: "#e5e7eb", // Tailwind’s bg-gray-300
          color: "#6b7280", // Tailwind’s text-gray-500
          border: "none",
          borderRadius: "9999px",
          padding: "8px 10px",
          cursor: "pointer",
          zIndex: 10000, // ensure it's above everything
        }}
      >
        <FaXmark />
      </button>

      {/* Modal content box */}
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          maxHeight: "90vh",
          borderRadius: 12,
          background: "#fff",
          padding: 20,
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          position: "relative",
          overflowY: "auto",
        }}
      >
        <AdyenPayment />
      </div>
    </div>
  );
}
